import { client } from '@/common-utils/libraries/axios/axios';
import { DOWNLOAD_CODES } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';
const mutationUpdateDownloadCode = (onSuccess, onError) => {
    return {
        mutationFn: ({ downloadCodeUuid, downloadCodeDataToSend }) => {
            return client.put(replaceParameters(DOWNLOAD_CODES.UPDATE.url, { downloadCodeUuid: downloadCodeUuid }), downloadCodeDataToSend);
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateDownloadCode;